/**
 * @voltxampere/schema — Group
 *
 * Per SPECS §1.5. A Group is a user-visible bundle of ComponentInstance
 * ids sharing a display name and optional color.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const GroupSchema = z
    .object({
    id: z.string(),
    name: z.string().max(100),
    componentIds: z.array(z.string()),
    color: z.string().optional(),
    collapsed: z.boolean().default(false),
})
    .strict();
//# sourceMappingURL=group.js.map